import { createContext } from 'react'

import type { RangeParams } from '@/services/api/params'
import type { DateRange, Period } from '@/shared/lib/period'

export interface PeriodContextValue {
  period: Period
  setPeriod: (period: Period) => void
  customRange: DateRange
  setCustomRange: (range: DateRange) => void
  /** Итоговый диапазон дат с учётом выбранного периода. */
  range: DateRange
  /** Тот же диапазон в виде параметров запроса к API. */
  rangeParams: RangeParams
}

export const PeriodContext = createContext<PeriodContextValue | null>(null)
